import { createSelector } from 'reselect';
import { STATE_NAME } from './constants';

const getCommonState = (state) => state[STATE_NAME];

const selectCountries = () =>
  createSelector(getCommonState, (state) => state.getIn(['listCountry']));

const selectCities = () =>
  createSelector(getCommonState, (state) => state.getIn(['listCity']));

const selectPhoneCodes = () =>
  createSelector(getCommonState, (state) => state.getIn(['listPhoneCode']));

const selectCategoriesSkills = () =>
  createSelector(getCommonState, (state) => state.getIn(['listCategorySkill']));

const selectCurrencies = () =>
  createSelector(getCommonState, (state) => state.getIn(['listCurrency']));

const selectLanguage = () =>
  createSelector(getCommonState, (state) => state.getIn(['lang']));

const selectCategories = () =>
  createSelector(getCommonState, (state) => state.getIn(['listCategories']));

const selectCampaignsMobile = () =>
  createSelector(getCommonState, (state) =>
    state.get('campaignsMobile').toJS()
  );

export {
  selectCountries,
  selectCities,
  selectPhoneCodes,
  selectCategoriesSkills,
  selectCurrencies,
  selectLanguage,
  selectCategories,
  selectCampaignsMobile,
};
